import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';

import { areSettingsLoaded } from 'app/features/settings/state/settings/settings.selectors';

export const settingsLoadedGuardFn: CanActivateFn = () => {
    const store = inject(Store);
    return store.select(areSettingsLoaded);
};
